// extracted by mini-css-extract-plugin
export default {"compareSwitch":"uV3E2f4G","controlElement":"IKFqlPMm"};